(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-masonry-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = Array.from(document.querySelectorAll('.editorial-masonry-gallery'));
    if (!sections.length) return;

    sections.forEach((section) => {
      const filters = Array.from(section.querySelectorAll('[data-filter]'));
      const items = Array.from(section.querySelectorAll('[data-lightbox-item]'));
      const gridItems = Array.from(section.querySelectorAll('.editorial-masonry-gallery__item'));
      const lightbox = section.querySelector('[data-lightbox]');
      const lightboxImage = lightbox?.querySelector('.editorial-masonry-gallery__lightbox-image');
      const lightboxTag = lightbox?.querySelector('.editorial-masonry-gallery__lightbox-tag');
      const lightboxCaption = lightbox?.querySelector('.editorial-masonry-gallery__lightbox-caption');
      const lightboxClose = lightbox?.querySelector('.editorial-masonry-gallery__lightbox-close');
      const lightboxPrev = lightbox?.querySelector('.editorial-masonry-gallery__lightbox-prev');
      const lightboxNext = lightbox?.querySelector('.editorial-masonry-gallery__lightbox-next');
      let activeFilter = 'all';
      let activeIndex = 0;
      let lastFocused = null;

      const getVisibleItems = () => {
        return items.filter((item) => !item.closest('.editorial-masonry-gallery__item')?.classList.contains('is-hidden'));
      };

      const setActiveFilter = (filter) => {
        activeFilter = filter;
        filters.forEach((button) => {
          const isActive = button.dataset.filter === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        gridItems.forEach((item) => {
          const category = item.dataset.category || '';
          const shouldShow = filter === 'all' || category === filter;
          item.classList.toggle('is-hidden', !shouldShow);
        });
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => setActiveFilter(button.dataset.filter));
      });

      const openLightbox = (item) => {
        if (!lightbox) return;
        const visibleItems = getVisibleItems();
        activeIndex = visibleItems.indexOf(item);
        if (activeIndex < 0) return;

        const update = () => {
          const current = visibleItems[activeIndex];
          const image = current.querySelector('img');
          if (!image) return;

          lightboxImage.src = image.currentSrc || image.src;
          lightboxImage.alt = current.dataset.alt || '';
          lightboxTag.textContent = current.dataset.category || '';
          lightboxCaption.textContent = current.dataset.caption || '';
          lightboxTag.hidden = !lightboxTag.textContent;
          lightboxCaption.hidden = !lightboxCaption.textContent;
        };

        update();
        lastFocused = document.activeElement;
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        lightboxClose?.focus();

        const showPrev = () => {
          activeIndex = (activeIndex - 1 + visibleItems.length) % visibleItems.length;
          update();
        };

        const showNext = () => {
          activeIndex = (activeIndex + 1) % visibleItems.length;
          update();
        };

        const onKeydown = (event) => {
          if (event.key === 'Escape') closeLightbox();
          if (event.key === 'ArrowLeft') showPrev();
          if (event.key === 'ArrowRight') showNext();
        };

        let touchStartX = 0;
        let touchEndX = 0;

        const onTouchStart = (event) => {
          touchStartX = event.changedTouches[0].clientX;
        };

        const onTouchEnd = (event) => {
          touchEndX = event.changedTouches[0].clientX;
          const delta = touchEndX - touchStartX;
          if (Math.abs(delta) > 50) {
            if (delta > 0) showPrev();
            else showNext();
          }
        };

        const closeLightbox = () => {
          lightbox.classList.remove('is-open');
          lightbox.setAttribute('aria-hidden', 'true');
          document.removeEventListener('keydown', onKeydown);
          lightbox.removeEventListener('touchstart', onTouchStart);
          lightbox.removeEventListener('touchend', onTouchEnd);
          lightbox.removeEventListener('click', onBackdropClick);
          lightboxClose?.removeEventListener('click', closeLightbox);
          lightboxPrev?.removeEventListener('click', showPrev);
          lightboxNext?.removeEventListener('click', showNext);
          lastFocused?.focus();
        };

        const onBackdropClick = (event) => {
          if (event.target === lightbox) {
            closeLightbox();
          }
        };

        document.addEventListener('keydown', onKeydown);
        lightbox.addEventListener('touchstart', onTouchStart, { passive: true });
        lightbox.addEventListener('touchend', onTouchEnd, { passive: true });
        lightbox.addEventListener('click', onBackdropClick);
        lightboxClose?.addEventListener('click', closeLightbox);
        lightboxPrev?.addEventListener('click', showPrev);
        lightboxNext?.addEventListener('click', showNext);
      };

      items.forEach((item) => {
        item.addEventListener('click', () => {
          if (!lightbox) return;
          openLightbox(item);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
